import Colors from '@dynatrace/strato-design-tokens/colors';

//region Default Values
export const DEFAULT_MIN_RANGE_VALUE = 0;
export const DEFAULT_MAX_RANGE_VALUE = 100;
export const DEFAULT_CHART_WIDTH = '100%';
export const DEFAULT_CHART_HEIGHT = 300;
//endregion

//region Sizes
export const MIN_SIZE_IN_PX = 100;
export const MIN_MAX_PADDING = 20;
export const MIN_MAX_LABEL_RESERVED_HEIGHT_IN_PX = 16;
export const ARC_OUTER_RADIUS_PERCENTAGE = 0.9;
export const ARC_INNER_RADIUS_PERCENTAGE = 0.8;
export const GAUGE_VERTICAL_SMALL_OFFSET = 0.05;
export const GAUGE_VERTICAL_DEFAULT_OFFSET = 0.1;
//endregion

// region Colors
export const ARC_BACKGROUND_COLOR = Colors.Theme.Neutral['40'];
export const ARC_DEFAULT_VALUE_COLOR =
  Colors.Charts.Categorical.Color11.Default;
export const THRESHOLD_COLOR_DEFAULT =
  Colors.Charts.Categorical.Color11.Default;
//endregion

// region Arc Properties
export const ARC_START_ANGLE = -0.625 * Math.PI; // −112.5º in radians
export const ARC_END_ANGLE = 0.625 * Math.PI; // 112.5º in radians
//endregion

//region Thresholds
export const THRESHOLD_LINE_WIDTH = 2;
export const THRESHOLD_LINE_DEFAULT_COLOR = Colors.Icon.Neutral.Default;
//endregion

//region Config Defaults
export const GAUGE_DEFAULT_CONFIG = {
  color: ARC_DEFAULT_VALUE_COLOR,
  min: DEFAULT_MIN_RANGE_VALUE,
  max: DEFAULT_MAX_RANGE_VALUE,
  formatter: undefined,
  loading: false,
  tooltip: {},
};
//endregion

export const DISPLAY_NAME = 'GaugeChart';

export const GAUGE_CHART_ARIA_LABEL = 'Gauge Chart';

export const FONT_HEIGHT_RATIO = 0.7;
export const DEFAULT_MAX_VALUE_FONT_SIZE = 240;

export const zIndexGaugeAreas = {
  toolbar: 2,
  tooltip: 1,
  overlay: 0,
};
